module.exports = __webpack_public_path__ + "static/s1-c-540-7d7aaf888277eff0ed275a816947619e.mp4";